import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import PlaidLink from "./PlaidLink";
import PersonaVerification from "./PersonaVerification";
import OnboardingFormPage from "./pages/OnboardingFormPage";
import OnboardingSuccess from "./pages/OnboardingSuccess";
import LandingPage from "./pages/LandingPage";

export const router = createBrowserRouter([
        {
            path: '/',
            element: <LandingPage />,
        },
        {
            path: '/form/:id',
            element: <OnboardingFormPage />,
        },
        {
            path: '/form/:id/success',
            element: <OnboardingSuccess />,
        },
]);

function Routes() {
    return (
        <RouterProvider router={router} />
    );
}

export default Routes;
